import React from 'react';
import { observer } from 'mobx-react';
import { AiServiceStore } from '@seedlang/stores';
import { isPresent } from '@seedlang/utils';
import Grid from 'components/layout/grid';
import ButtonPrimary from 'components/button/button_primary';

@observer
class AiServiceCreate extends React.Component {

  onClick() {
    if (isPresent(this.refs.model.value) && isPresent(this.refs.client.value)) {
      AiServiceStore.create(
        {
          data: {
            model: this.refs.model.value,
            client: this.refs.client.value,
          },
        },
      );
      this.refs.model.value = '';
    }
  }

  render() {
    return (
      <Grid columns={[2,2,1]} gap='sm'>
        <select ref='client'>
          {this.props.clientOptions.map(item => { return (<option key={item} value={item}>{item}</option>); })}
        </select>
        <input
          placeholder='Model'
          ref='model'
        />
        <ButtonPrimary onClick={this.onClick.bind(this)} >
          Create
        </ButtonPrimary>
      </Grid>
    );
  }
}

export default AiServiceCreate;
